import React, { createContext, useContext, useEffect, useState } from "react";
import { getMe, login as apiLogin, logout as apiLogout } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = logged out, obj = logged in

  useEffect(() => {
    getMe()
      .then((u) => setUser(u))
      .catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const data = await apiLogin(email, password);
    const me = await getMe().catch(() => data);
    setUser(me);
    return me;
  };

  const logout = async () => {
    await apiLogout().catch(() => {});
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, login, logout, setUser }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
